/* eslint-disable jira/filename-case */
import { isProjectsInJiraM1Enabled } from '@jira/platform__services-native-integration-projects/src/index.tsx';

const isProjectsInJiraEapDrop1Enabled = {
	get(): boolean {
		return isProjectsInJiraM1Enabled();
	},
};

export default isProjectsInJiraEapDrop1Enabled;
